module.exports = __webpack_public_path__ + "media/images/icon-item-blue-2a22b43be6162c3408b581c73e4de07e.svg";